export enum MENU_OPTIONS {
  PARTNERS = 'PARTNERS',
  PRODUCT = 'PRODUCT',
  TRACKS = 'TRACKS',
  RESOURCES = 'RESOURCES',
  PRICING = 'PRICING',
}

export const EVENTS = {
  HERO_BANNER_CTA: 'HERO_BANNER_CTA',
  HERO_BANNER_VIDEO: 'HERO_BANNER_VIDEO',

  [MENU_OPTIONS.PARTNERS]: 'MAIN_HEADER_PARTNERS',

  MAIN_HEADER_PARTNERS_PARTNERSHIPS: 'MAIN_HEADER_PARTNERS_PARTNERSHIPS',
  MAIN_HEADER_PARTNERS_REFERRALS: 'MAIN_HEADER_PARTNERS_REFERRALS',

  [MENU_OPTIONS.PRODUCT]: 'MAIN_HEADER_PRODUCT',

  MAIN_HEADER_PRODUCT_DETAIL_SKILL_IQ_TEST:
    'MAIN_HEADER_PRODUCT_DETAIL_SKILL_IQ_TEST',
  MAIN_HEADER_PRODUCT_DETAIL_DEVELOPMENT:
    'MAIN_HEADER_PRODUCT_DETAIL_DEVELOPMENT',
  MAIN_HEADER_PRODUCT_DETAIL_CLASSROOMS:
    'MAIN_HEADER_PRODUCT_DETAIL_CLASSROOMS',
  MAIN_HEADER_PRODUCT_DETAIL_DATA_ANALYSIS:
    'MAIN_HEADER_PRODUCT_DETAIL_DATA_ANALYSIS',

  [MENU_OPTIONS.TRACKS]: 'MAIN_HEADER_TRACK',

  MAIN_HEADER_TRACK_DETAIL_SALES: 'MAIN_HEADER_TRACK_DETAIL_SALES',
  MAIN_HEADER_TRACK_DETAIL_INNOVATION: 'MAIN_HEADER_TRACK_DETAIL_INNOVATION',
  MAIN_HEADER_TRACK_DETAIL_DIGITAL_MINDSET:
    'MAIN_HEADER_TRACK_DETAIL_DIGITAL_MINDSET',
  MAIN_HEADER_TRACK_DETAIL_DATA_ANALYSIS:
    'MAIN_HEADER_TRACK_DETAIL_DATA_ANALYSIS',
  MAIN_HEADER_TRACK_DETAIL_LEADERSHIP: 'MAIN_HEADER_TRACK_DETAIL_LEADERSHIP',
  MAIN_HEADER_TRACK_DETAIL_ECOMMERCE: 'MAIN_HEADER_TRACK_DETAIL_ECOMMERCE',
  MAIN_HEADER_TRACK_DETAIL_DIGITAL_MARKETING:
    'MAIN_HEADER_TRACK_DETAIL_DIGITAL_MARKETING',
  MAIN_HEADER_TRACK_DETAIL_UXUI: 'MAIN_HEADER_TRACK_DETAIL_UXUI',

  MAIN_HEADER_RESOURCES_BLOG: 'MAIN_HEADER_RESOURCES_BLOG',
  MAIN_HEADER_RESOURCES_DOWNLOADABLES: 'MAIN_HEADER_RESOURCES_DOWNLOADABLES',

  MAIN_HEADER_INDUSTRIES: 'MAIN_HEADER_INDUSTRIES',

  [MENU_OPTIONS.RESOURCES]: 'MAIN_HEADER_RESOURCES',
  [`${MENU_OPTIONS.RESOURCES}_DETAIL`]: 'MAIN_HEADER_RESOURCE_DETAIL',
  [MENU_OPTIONS.PRICING]: 'MAIN_HEADER_PRICING',
  MAIN_HEADER_CTA: 'MAIN_HEADER_CTA',
  MAIN_HEADER_CALL_US: 'MAIN_HEADER_CALL_US',

  LEARN_SECTION_CLASSROOMS: 'LEARN_SECTION_CLASSROOMS',
  LEARN_SECTION_DEVELOPMENT: 'LEARN_SECTION_DEVELOPMENT',
  PERFORMACE_SECTION: 'PERFORMACE_SECTION',
  SKILL_IQ_HOME_SECTION: 'SKILL_IQ_HOME_SECTION',

  TRACKS_SECTION_SHOW_ALL_TRACKS: 'TRACKS_SECTION_SHOW_ALL_TRACKS',
  TRACKS_SECTION_SALES: 'TRACKS_SECTION_SALES',
  TRACKS_SECTION_LEADERSHIP: 'TRACKS_SECTION_LEADERSHIP',
  TRACKS_SECTION_INNOVATION: 'TRACKS_SECTION_INNOVATION',
  TRACKS_SECTION_ECOMMERCE: 'TRACKS_SECTION_ECOMMERCE',

  VIDEO_SECTION_CTA: 'VIDEO_SECTION_CTA',

  TRACK_DETAIL_HERO: 'TRACK_DETAIL_HERO',
  PRODUCT_DETAIL_HERO: 'PRODUCT_DETAIL_HERO',
  LOWER_BANNER: 'LOWER_BANNER',

  FREE_TRIAL_SUCCESSFUL_REQUEST: 'FREE_TRIAL_SUCCESSFUL_REQUEST',
  FREE_TRIAL_ERROR_REQUEST: 'FREE_TRIAL_ERROR_REQUEST',

  PRICING_TEAM_PLAN: 'Pricing Team Plan',
  PRICING_BUSINESS_PLAN: 'Pricing Business Plan',
  PRICING_TABLE_CTA: 'Pricing Table CTA',
  PRICING_FIXED_BAR: 'Pricing Fixed Bar',
  PRICING_RENDER_DIALOG_TEAM_PLAN: 'PRICING_RENDER_DIALOG_TEAM_PLAN',
  PRICING_DIALOG_TEAM_PLAN_LICENSES: 'PRICING_DIALOG_TEAM_PLAN_LICENSES',

  FOOTER_PRODUCT_SKILL_IQ: 'FOOTER_PRODUCT_SKILL_IQ',
  FOOTER_PRODUCT_SKILL_DEVELOPMENT: 'FOOTER_PRODUCT_SKILL_DEVELOPMENT',
  FOOTER_PRODUCT_SKILL_CLASSROOMS: 'FOOTER_PRODUCT_SKILL_CLASSROOMS',
  FOOTER_PRODUCT_SKILL_DATA_ANALYSIS: 'FOOTER_PRODUCT_SKILL_DATA_ANALYSIS',
  FOOTER_PRODUCT_SKILL_HIGHER_EDUCATION:
    'FOOTER_PRODUCT_SKILL_HIGHER_EDUCATION',

  FOOTER_TRACKS_SALES: 'FOOTER_TRACKS_SALES',
  FOOTER_TRACKS_INNOVATION: 'FOOTER_TRACKS_INNOVATION',
  FOOTER_TRACKS_DIGITAL_MINDSET: 'FOOTER_TRACKS_DIGITAL_MINDSET',
  FOOTER_TRACKS_DATA_ANALYSIS: 'FOOTER_TRACKS_DATA_ANALYSIS',
  FOOTER_TRACKS_LEADERSHIP: 'FOOTER_TRACKS_LEADERSHIP',
  FOOTER_TRACKS_ECOMMERCE: 'FOOTER_TRACKS_ECOMMERCE',
  FOOTER_TRACKS_DIGITAL_MARKETING: 'FOOTER_TRACKS_DIGITAL_MARKETING',
  FOOTER_TRACKS_UXUI: 'FOOTER_TRACKS_UXUI',

  FOOTER_RESOUCES_BLOG: 'FOOTER_RESOUCES_BLOG',
  FOOTER_RESOUCES_HELP_CENTER: 'FOOTER_RESOUCES_HELP_CENTER',

  B2B_LANDING_FREE_TRIAL_FORM: 'B2B_LANDING_FREE_TRIAL_FORM',
  B2B_LANDING_HOME: 'B2B_LANDING_HOME',
  B2B_LANDING_ACADEMIES: 'B2B_LANDING_ACADEMIES',
  B2B_LANDING_PRICING: 'B2B_LANDING_PRICING',
  B2B_LANDING_PRODUCT_DETAIL: 'B2B_LANDING_PRODUCT_DETAIL',
  B2B_LANDING_TRACK_DETAIL: 'B2B_LANDING_TRACK_DETAIL',
  B2B_LANDING_TRACK: 'B2B_LANDING_TRACK',
};

export const AMPLITUDE_TRACKS = {
  LANDING_PAGE_VIEWED: 'Landing Page Viewed',
  FORM_VIEWED: 'Form Viewed',
  LEAD_SENT: 'Lead Sent',
  LEAD_SENT_VARIANT: 'Lead Sent Variant',
  PRICING_PAGE_VIEWED: 'Pricing Page Viewed',
  WANTS_TO_KNOW_MORE: 'Wants To Know More',
  MENU_OPENED: 'Menu Opened',
  MENU_OPTION_CLICKED: 'Menu Option Clicked',
  WANTS_TO_LEARN_ABOUT_FEATURE: 'Wants To Learn About Feature',
  WATCH_VIDEO_BUTTON_CLICKED: 'Watch Video Button Clicked',
  FINANCIAL_INDUSTRY_LANDING_PAGE_VIEWED:
    'Financial Industry Landing Page Viewed',
  MAIN_HEADER_CALL_US: 'Main Header Call Us',
  B2B_LANDING: 'B2B Landing',
  RENDER_LANDING_PARTNERSHIPS: 'Render Page Partnerships',
  LEAD_SENT_PARTNERSHIPS: 'Submit Form Partnerships',
  RENDER_LANDING_REFERRALS: 'Render Page Referrals',
  LEAD_SENT_REFERRALS: 'Submit Form Referrals',
  DOWNLOADED_RESOURCE: 'Downloaded Resource',
  RENDER_B2B_RMKT: 'Render Landing B2B RMKT',
};
